import { Logo } from "common/components/Logo";
import { useAppDispatch, useAppSelector } from "common/hooks/storeHooks";
import { getUrl } from "common/records/Image";
import { AuthAsyncActions } from "common/reducers/auth.async.actions";
import { UserActions } from "common/reducers/user.actions";
import { accessById } from "common/selectors/access.selectors";
import { orgOverview, orgOverviewLogo } from "common/selectors/org.selectors";
import React from "react";
import { useNavigate } from "react-router";

export interface AccessResultProps {
  accessId: number;
  selectedIndex: number;
  close: () => void;
  query: string;
  index: number;
}

export const AccessResult: React.FC<AccessResultProps> = ({ accessId, selectedIndex, close, query, index }) => {
  // Hooks
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  // Selectors
  const access = useAppSelector((state) => accessById(state, { accessId }));
  const org = useAppSelector((state) => orgOverview(state, { orgId: access?.org_id }));
  const logo = useAppSelector((state) => orgOverviewLogo(state, { orgId: access?.org_id }));

  // Methods
  const highlightQuery = (text: string, query: string) => {
    if (!query) return text;
    const parts = text.split(new RegExp(`(${query})`, "gi"));
    return parts.map((part, index) =>
      part.toLowerCase() === query.toLowerCase() ? (
        <span key={index} className="bg-yellow-200 font-semibold">
          {part}
        </span>
      ) : (
        part
      ),
    );
  };

  const changeAccess = async () => {
    if (access?.uid) {
      dispatch(UserActions.removeCurrentUser());
      await dispatch(AuthAsyncActions.changeAccessUid(access?.uid));
      navigate("/jobs?org_id=" + access?.org_id);
      close();
    }
  };

  return (
    <li
      key={index}
      onClick={changeAccess}
      className={`p-2 cursor-pointer flex items-center ${
        selectedIndex === index ? "bg-primary-100" : "hover:bg-gray-100"
      }`}>
      <span className="mr-3 px-2 py-1 text-sm font-semibold text-purple-700 bg-purple-100 rounded">
        Select Org Access
      </span>
      {logo && (
        <div className="h-[40px] mr-sm">
          <Logo src={getUrl(logo, "small")} alt={org?.name + " Logo" || ""} />
        </div>
      )}
      <span>{highlightQuery(org?.name || "", query)}</span>
    </li>
  );
};
